export default __webpack_public_path__ + "locales/en/VersionHistory.json?hash=a3490484013d3ab3cc79bf5972b74b75";